import {dataFetcher} from "../../services/dataGuetter/dataFetcher";


export async function getAllModuleCarte(id:number):Promise<ModuleCarte[]>{
    const res:any = await dataFetcher(`module_cartes?Centre=${id}`)
    return res["hydra:member"]
}